export default __webpack_public_path__ + "static/media/uranus.655c64b5.png";